import { handleEvent } from '../../helpers';

export default class {
  constructor(el) {
    this.DOM = {}
    this.DOM.el = el
    this.DOM.videoButton = el.querySelector('.video-click')
    this.DOM.overlay = el.querySelector('.video-overlay')
    this.DOM.video = el.querySelector('video')
  }

  init() {
    this.handleEvents();
  }

  handleEvents() {
    this.playEvent = handleEvent('click', {
      el: this.DOM.videoButton,
      callback: this.play.bind(this)
    });

    // this.videoStop = handleEvent('click', {
    //   el: this.DOM.video,
    //   callback: () => {
    //     this.pause()
    //   }
    // });
  }

  play() {
    this.playing = true
    this.DOM.video.play();
    this.DOM.video.volume = 0.3
    this.DOM.video.setAttribute('controls', 'true')
    this.DOM.overlay.classList.add('hidden')

  }

  destroy() {
    this.playEvent.destroy();
    // this.videoStop.destroy();
  }
}
